<template>
  <div class="formLead bg-formLead iframehtml">
    <div id="contact" class="container iframehtml pt-3 pb-2 mb-5">
      <h1 class="center" style="color: #14b1ff">CONTATO</h1>
      <div class="row iframehtml">
        <div class="col-lg-7 iframehtml col-xs-12 d-flex flex-column">
          <input
            type="text"
            class="input_form_lead mt-2 mb-2"
            placeholder="NOME"
            v-model="lead.name"
          />
          <input
            type="text"
            class="input_form_lead mt-2 mb-2"
            placeholder="ASSUNTO"
            v-model="lead.subject"
          />
          <textarea
            class="input_form_lead mt-1 mb-5"
            placeholder="MENSAGEM"
            rows="8"
            v-model="lead.message"
          ></textarea>
        </div>
        <div class="col-lg-5 col-xs12 d-flex flex-column">
          <input
            type="text"
            class="input_form_lead mt-2 mb-2"
            placeholder="EMAIL"
            v-model="lead.email"
          />
          <input
            type="text"
            class="input_form_lead mt-2 mb-2"
            placeholder="TELEFONE"
            v-model="lead.mobile_phone"
          />
          <input
            type="text"
            class="input_form_lead mt-2 mb-2"
            placeholder="EMPRESA"
            v-model="lead.company"
          />
          <div class="center pt-3">
            <button class="sendEmail mt-5" @click="sendLead">ENVIAR</button>
          </div>
        </div>
        <div v-if="info" class="col-lg-12 col-xs-12">
          <p class="color-white">
            Av. Eng. Luís Carlos Berrini, 1511 | 11 andar | Brooklin | São Paulo
            <!-- - SP | 04571-011 | +55 21 971 059 337 | +55 11 941 425 115 | -->
            contato@jovool.com
          </p>
          <inertia-link href="/recruiters/dashboard/choose">
            <button type="button" class="btn btn-secondary">VOLTAR</button>
          </inertia-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["info"],
  data() {
    return {
      lead: {
        name: "",
        email: "",
        subject: "",
        company: "",
        message: "",
        mobile_phone: "",
      },
    };
  },
  methods: {
    fields() {
      if (
        this.lead.name == "" ||
        this.lead.email == "" ||
        this.lead.mobile_phone == "" ||
        this.lead.subject == "" ||
        this.lead.message == ""
      ) {
        return false;
      }
    },
    sendLead() {
      if (this.fields() == false) {
        this.$toast.error("PREENCHA TODOS OS CAMPOS POR FAVOR");
        return;
      }
      console.log(this.lead);
      axios.post("lead/create", {
        lead: {
          name: this.lead.name,
          email: this.lead.email,
          subject: this.lead.subject,
          company: this.lead.company,
          message: this.lead.message,
          mobile_phone: this.lead.mobile_phone,
        },
      }),
        (this.lead = {
          name: "",
          email: "",
          subject: "",
          company: "",
          message: "",
          mobile_phone: "",
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>